"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_shopping__trolley(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "shopping-trolley-mid"), /*#__PURE__*/React.createElement("g", {
    id: "e47b56bb-5294-41fb-9503-e3343e4b33fe",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3b4c7edd-f342-426e-87f3-5a4542d052a6",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d8c769b7-63d2-4965-91b5-99a1efbb7a11",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "90d3cb02-e24e-4ebf-896a-01b41e7cc1b1",
    "data-name": "<Pfad>",
    cx: 88,
    cy: 152,
    r: 14,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "a9b302d2-abea-4753-be2a-3847d7c295af",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "33f20a86-3129-4fcc-b7f7-4e5aa66ccd1b",
    "data-name": "<Pfad>",
    cx: 136,
    cy: 152,
    r: 14,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "18 26 44 26 76 118 148 118 174 46 50.96 46",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))));
}

var _default = ic_shopping__trolley;
exports.default = _default;